// 搜索类型枚举
export const SEARCH_TYPES = {
  BY_NAME: '1',
  BY_BRAND: '2',
  BY_PROPERTY: '3',
  ALL_GOODS: '4'
}

// 搜索类型标签
export const SEARCH_TYPE_LABELS = {
  [SEARCH_TYPES.BY_NAME]: '商品名称',
  [SEARCH_TYPES.BY_BRAND]: '品牌名称',
  [SEARCH_TYPES.BY_PROPERTY]: '商品属性',
  [SEARCH_TYPES.ALL_GOODS]: '所有商品'
}

// 商品状态枚举
export const GOODS_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  DELETED: 'deleted'
}

// 商品状态标签
export const GOODS_STATUS_LABELS = {
  [GOODS_STATUS.ACTIVE]: '正常',
  [GOODS_STATUS.INACTIVE]: '停用',
  [GOODS_STATUS.DELETED]: '已删除'
}

// 文件类型枚举
export const FILE_TYPES = {
  IMAGE: 'image',
  DOCUMENT: 'document',
  VIDEO: 'video',
  AUDIO: 'audio'
}

// 用户角色枚举
export const USER_ROLES = {
  ADMIN: 'admin',
  USER: 'user',
  GUEST: 'guest'
}

// 用户角色标签
export const USER_ROLE_LABELS = {
  [USER_ROLES.ADMIN]: '管理员',
  [USER_ROLES.USER]: '普通用户',
  [USER_ROLES.GUEST]: '访客'
}



// WEBPACK FOOTER //
// ./src/constants/enums.js